import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Link from 'next/link';
import Image from 'next/image'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPaperPlane, faStopwatch, faUser, faComments, faPoundSign} from '@fortawesome/free-solid-svg-icons';
import TutorProfileSubjectList from './TutorProfileSubjectList'
import TutorProfileRate from './TutorProfileRate'
import TutorProfileRating from './tutorProfile/Rating'
import styles from './TutorSearchResultsRow.module.scss'

export default function TutorSearchResultsRow({tutorProfile, subject, level}) {
  const hasTaughtTenHours = (() => {
    return tutorProfile.totalLessonMinutes > 600
  })()
  const lessonHoursLabel = (() => {
    const lessonHours = tutorProfile.totalLessonHours
    if(!lessonHours) return

    const roundedLessonHours = Math.ceil(lessonHours / 5) * 5
    return `${roundedLessonHours}+`
  })()
  const showRating = (tutorProfile.tutorReviewsCount > 0)

  return (
    <div>
      <Card>
        <Card.Body>
          <Row>
            <Col xs={12} md={3} className="text-center">
              <Image
                src={tutorProfile.profilePicture.thumb.url}
                className="rounded"
                width={150}
                height={150}
                alt="Profile picture"
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </Col>

            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <div className="d-block d-md-flex">
                <div className="d-md-flex mb-2">
                  <Card.Title className="my-auto me-md-2 mb-2 mb-md-0 d-flex">
                    <Link href={`/tutors/${tutorProfile.slug}`} passHref>
                      {tutorProfile.firstNameAndLastInitial}
                    </Link>

                    {showRating &&
                      <div className={`${styles.ratingContainer} ms-2`}>
                        <TutorProfileRating tutorProfile={tutorProfile} showCount={false} size={20} />
                      </div>
                    }
                  </Card.Title>
                </div>
              </div>
              <Card.Text>{tutorProfile.tagLine}</Card.Text>

              <TutorProfileSubjectList tutorProfile={tutorProfile} subjects={tutorProfile.subjects} />
            </Col>

            <Col xs={12} md={3} className="d-md-flex">
              <div className="d-flex flex-column mx-auto w-100">
                <div>
                  <FontAwesomeIcon icon={faPoundSign} size="lg" fixedWidth className="me-1 my-auto text-success" />
                  <h5 className="d-inline fs-3">
                    <TutorProfileRate subject={subject}
                                      level={level}
                                      subjectLevels={tutorProfile.subjectLevels}
                                      modality="online" />
                  </h5>
                </div>

                <div className="mt-3 mb-3">
                  {tutorProfile.averageRequestResponseTimeLabel &&
                    <div className="mb-2">
                      <FontAwesomeIcon icon={faPaperPlane} size="lg" fixedWidth className="me-1 text-success" />
                      <span>Responds in {tutorProfile.averageRequestResponseTimeLabel}</span>
                    </div>
                  }

                  {hasTaughtTenHours &&
                    <div>
                      <FontAwesomeIcon icon={faStopwatch} size="lg" fixedWidth className="me-1 text-success" />
                      <span>{lessonHoursLabel} hours taught</span>
                    </div>
                  }
                </div>

                <div className="mt-auto">
                  <Link
                    href={`/tutors/${tutorProfile.slug}`}
                    passHref
                    className="mb-md-2 btn btn-outline-secondary d-block"
                  >
                    <FontAwesomeIcon icon={faUser} className="me-1" />View Profile
                  </Link>
                  <Link
                    href={`/tutors/${tutorProfile.slug}/send-message`}
                    passHref
                    className="mb-md-2 btn btn-primary d-block"
                  >
                    <FontAwesomeIcon icon={faComments} className="me-1" />Send Message
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  )
}
